'use strict';

export default function routes($stateProvider) {
    'ngInject'

    $stateProvider.state('main.device_error', {
        url: 'device_error',
        template: '<device_error></device_error>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/device_error/device_error.routes.js